import { component } from 'picoapp'
import { removeAddon, updateAddon } from '@/lib/cart.js'

export default component((node, ctx) => {
    const 
        button = node.querySelector('.js-remove-item'),
        decrease = node.querySelector('.js-remove-single'),
        increase = node.querySelector('.js-add-single'),
        currentQty = node.querySelector('.js-single-quantity').innerHTML,
        id = node.getAttribute('data-id')

    button.addEventListener('click', () => {
        removeAddon(id)
    })

    if (decrease) {
        decrease.addEventListener('click', (e) => {
            e.preventDefault()
            updateAddon(id, parseInt(currentQty) - 1)
        })
    }

    if (increase) {
        increase.addEventListener('click', (e) => {
            e.preventDefault()
            updateAddon(id, parseInt(currentQty) + 1)
        })
    }
})